import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { BrandPriceList } from "@NA/Store/Data/ADIRequestPriceListState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export interface RequestPriceListParameter extends ApiParameter {
    brandData: BrandPriceList[];
}

export interface RequestPriceListModel {
    brandData: BrandPriceList[];
}

type HandlerType = CustomApiHandler<RequestPriceListParameter, RequestPriceListModel>;

export const DispatchRequestPriceList: HandlerType = (props: any) => {
    props.parameter.expand= "properties";
    props.dispatch({
        type: "Common/RequestPriceList",
        result: props.parameter.brandData,
    });
};

export const DispatchRequestHeader: HandlerType = (props: any) => {
    const state = props.getState();
    const cart = getCurrentCartState(state);
    const billToState = getBillToState(state, cart?.value?.billToId).value;
    const session = state.context.session;
    const requestHeader = {
        customerNumber: billToState?.customerNumber,
        userID: session.userName,
        userEmail: session.email,
        recordCount: "",
        requestId: "",
        requestVersion: "1.0",
        returnCode: "",
        returnMessage: "",
    };
    props.dispatch({
        type: "Common/RequestPriceHeader",
        result: requestHeader,
    
    });
};
export const DispatchRequestPriceRadio: HandlerType = (props: any) => {
    props.dispatch({
        type: "Common/RequestPriceList",
        result: props.parameter.radio,
    });
};

export const chain = [DispatchRequestPriceList, DispatchRequestHeader];

const brandDataPriceList = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        brandData: [],
    },
    "brandDataPriceList",
);
export default brandDataPriceList;
